// initial state
const state = {
  SCREEN_XS_MAX: 575.98, // Extra Small
  SCREEN_SM_MAX: 767.98, // Small
  SCREEN_MD_MAX: 991.98, // Medium
  SCREEN_LG_MAX: 1199.98, // Large
  SCREEN_XL_MAX: 4999.98, // Extra Large
  // Firebase Project Info Found at https://console.firebase.google.com/u/0/project/bmg-llc/settings/general/
  FIREBASE_PROJECT: {
    apiKey: 'AIzaSyBAYW1whSOWQMjf9JFzfrVglpH78Bsl2OU',
    authDomain: 'bmg-llc.firebaseapp.com',
    databaseURL: 'https://bmg-llc.firebaseio.com',
    projectId: 'bmg-llc',
    storageBucket: 'bmg-llc.appspot.com',
    messagingSenderId: '571080524284',
    appId: '1:571080524284:web:6eb3a0ff0cd60f02'
  }
}

export default {
  state
}
